/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useRef } from 'react'
import { Modal, ModalProps } from 'react-bootstrap'
import Draggable from 'react-draggable'
import './ActiveCallModalStyle.css'
import '../../Modals/ModalStyle.css'
import { useAppSelector } from '@store/hooks'
import ActiveCall from '@components/layout/ActiveCall/ActiveCall.component'

type ActiveCallProps = {
  show: boolean
  onHide?: () => void
}

const DraggableModalDialog = (props: ModalProps) => {
  const nodeRef = useRef<HTMLDivElement>(null)
  return (
    <Draggable handle=".acc-drag-button" nodeRef={nodeRef}>
      <Modal.Dialog {...props} ref={nodeRef} />
    </Draggable>
  )
}

function ActiveCallModal({ ...props }: ActiveCallProps): React.ReactElement {
  const callerInfo = useAppSelector((state) => state.calls.callerInfo)

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      backdrop={false}
      enforceFocus={false}
      keyboard={false}
      className={`active-call-modal${callerInfo?.call_type !== 'Incoming' ? ' active' : ''}`}
      size="sm"
      dialogAs={DraggableModalDialog}
    >
      <ActiveCall show={props.show} isModal={true} />
    </Modal>
  )
}

export default ActiveCallModal
